import styled from "styled-components";

interface Props {
  index: number;
  count: number;
  label: string;
  color: string;
}

const Labels = ({ count, label,color }: Props) => {
  return (
    <StyledPieLabel>
      <Count>{count}</Count>
      <div style={{ width: "10%", display:'flex',flex:1}}>
        <div>
          <CircleColor color={color} />
        </div>
      </div>
      <Label>{label}</Label>
    </StyledPieLabel>
  );
};
const StyledPieLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  margin:0.25rem 0;
`;
const Count = styled.div`
  width: 45%;
  font-weight: 500;
  font-size: 1.25rem;
  text-align: right;
`;
const CircleColor = styled.div`
  height: 1.5rem;
  width: 1.5rem;
  background: ${(props) => props.color};
  border-radius: 0.75rem;
`;
const Label = styled.div`
  width: 45%;
  font-weight: 100;
  font-size: 0.8rem;
  text-align: left;
`;

export default Labels;
